var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatPreviewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 5C8.9 4.50294 8.49706 4.1 8 4.1C7.50294 4.1 7.1 4.50294 7.1 5H8.9ZM36 20.9C36.4971 20.9 36.9 20.4971 36.9 20C36.9 19.5029 36.4971 19.1 36 19.1V20.9ZM7.1 5V10H8.9V5H7.1ZM18 20.9H36V19.1H18V20.9ZM7.1 10C7.1 16.0199 11.9801 20.9 18 20.9V19.1C12.9742 19.1 8.9 15.0258 8.9 10H7.1Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20L36.6364 20.6364C36.9879 20.2849 36.9879 19.7151 36.6364 19.3636L36 20ZM32.6364 15.3636C32.2849 15.0121 31.7151 15.0121 31.3636 15.3636C31.0121 15.7151 31.0121 16.2849 31.3636 16.6364L32.6364 15.3636ZM31.3636 23.3636C31.0121 23.7151 31.0121 24.2849 31.3636 24.6364C31.7151 24.9879 32.2849 24.9879 32.6364 24.6364L31.3636 23.3636ZM36.6364 19.3636L32.6364 15.3636L31.3636 16.6364L35.3636 20.6364L36.6364 19.3636ZM35.3636 19.3636L31.3636 23.3636L32.6364 24.6364L36.6364 20.6364L35.3636 19.3636Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPreviewArrow);
export default __webpack_public_path__ + "static/media/ChatPreviewArrow.5e96596a87eb6be36d70a6ad53ca5f48.svg";
export { ForwardRef as ReactComponent };